(function () {
    'use strict';

    function canShare(data) {
        if (typeof navigator.share !== 'function') return false;
        if (typeof navigator.canShare === 'function') {
            return navigator.canShare(data);
        }

        return true;
    }

    function init() {
        const shareButton = document.querySelector('.js-share');
        if (!shareButton) return;

        const shareData = {
            title: document.title,
            url: window.location.href,
        }

        if (!canShare(shareData)) {
            return shareButton.remove();
        }

        shareButton.addEventListener('click', async (e) => {
            e.preventDefault();

            try {
                await navigator.share(shareData);
            } catch (error) {
                if (error.name !== 'AbortError') {
                    shareButton.blur();
                }
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();